"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getAuthAndCorrelationHeaders(accessToken, correlationId) {
    const authorization = `Bearer ${accessToken}`;
    return {
        authorization,
        'x-request-id': correlationId,
    };
}
exports.getAuthAndCorrelationHeaders = getAuthAndCorrelationHeaders;
//# sourceMappingURL=header.js.map